import { format } from 'date-fns';
import { localeDateMappings } from '../constants/dataConstants';
import moment from 'moment';

export function formatDate(
  date: any,
  country: string,
  formatType: 'short' | 'long' | 'dateTime' = 'short'
): string {
  const { dateFormat, longDateFormat, dateTimeFormat } = localeDateMappings[country] || {
    dateFormat: 'MM/dd/yyyy',
    longDateFormat: 'MMMM dd, yyyy',
    dateTimeFormat: 'MM/dd/yy h:mma',
  };
  let formatString: string;
  const newDate = new Date(date);
  if (!date || isNaN(newDate.getTime())) {
    return '';
  }

  switch (formatType) {
    case 'long':
      formatString = longDateFormat;
      break;
    case 'dateTime':
      formatString = dateTimeFormat;
      break;
    case 'short':
    default:
      formatString = dateFormat;
  }
  let formattedDate = format(newDate, formatString);

  if (formatType === 'dateTime') {
    formattedDate = formattedDate.replace('AM', 'am').replace('PM', 'pm');
  }
  return formattedDate;
}

export const formatDateShort = (dateString: Date | undefined) => {
  return moment(dateString).format('MMM DD, YYYY');
};

export const getCurrentPerformanceYear = (
  closingMonth: string | undefined | null
): number | undefined => {
  if (!closingMonth) {
    return undefined;
  }
  const year = closingMonth.slice(0, 4);
  const month = closingMonth.slice(4, 6);
  return getFiscalYear(Number(year), Number(month));
};

export const getFiscalYear = (year: number, month: number): number => {
  let fiscalYear = year;
  if (year && month) {
    if (month > 8) {
      fiscalYear++;
    }
  }
  return fiscalYear;
};
